import { useQuery } from "@tanstack/react-query";

import {
  type CxpReconciliationFilters,
  cxpReconciliationService,
} from "~/services/contabilidad/cxpReconciliationService";

export const CXP_RECONCILIATION_QUERY_KEY = ["cxp-reconciliation"];

export function useCxpReconciliation(filters: CxpReconciliationFilters) {
  return useQuery({
    queryKey: [...CXP_RECONCILIATION_QUERY_KEY, filters],
    queryFn: () => cxpReconciliationService.getReconciliation(filters),
    enabled: !!filters.initialDate && !!filters.finalDate,
  });
}
